angular.module('ihestiaWidgets.eua.documentStatusDetails', [
  'ihestiaWidgets.eua'
]);